import { Col, Row } from "react-bootstrap";
import { renderScoreTrendIcon, renderSongScore } from "../helperRenders";
import moment from "moment/min/moment-with-locales";

export default function SongScoreRow({ item, setCatalogueSong }) {
    return (
        <Row onClick={() => setCatalogueSong(item.song)} className={`py-1 border-bottom align-items-center hoverable fs-8-xs`}>
            <Col xs={"auto"} xl className={`align-content-center fs-7 fw-bold fw-xl-normal`}>
                {item.song.artist}
            </Col>
            <Col xs="auto" className=" align-content-center px-0 d-xl-none">
                -
            </Col>
            <Col xs={"auto"} xl className=" align-content-center fs-7 fw-bold fw-xl-normal">
                {item.song.title}
            </Col>
            <Col xs={12} className="d-xl-none"></Col>
            <Col xs={"auto"} xl={2} className=" align-self-center text-center">
                <span className=" d-xl-none">Release year: </span>
                <span className=" fw-bold fw-xl-normal">{item.song.release_year}</span>
            </Col>
            <Col xs={"auto"} xl={1} className="d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Score:</span>
                {renderSongScore(item.music_test_data.song_score)}
            </Col>
            <Col xs={"auto"} xl={1} className=" d-flex align-items-center column-gap-2 justify-content-center">
                <span className=" d-xl-none">Trend:</span>
                {renderScoreTrendIcon(item.music_test_data.song_score_trend)}
            </Col>
            <Col xs={"auto"} xl={2} className=" align-content-center text-center">
                <span className=" d-xl-none">First played: </span>
                <span className=" fw-bold fw-xl-normal">{moment(item.music_test_data.first_play).format("L HH:mm")}</span>
            </Col>
        </Row>
    );
}
